require('lib/browser_required')('lib/backbone_serialize')

const Backbone = require('backbone')

// add a serialize method to Backbone.Model to incorporate calculated attributes
Backbone.Model.prototype.serialize = function serialize() {
    const json = this.toJSON.apply(this, arguments)
    const calced = this.calculated_values || {}
    Object.keys(calced).forEach(key => {
        let result = calced[key].call(this)
        if (
            result instanceof Backbone.Model
            || result instanceof Backbone.Collection
        ) {
            result = result.serialize()
        }
        json[key] = result
    })
    return json
}

// add a serialize method to Backbone.Collection to incorporate calculated
// attributes
Backbone.Collection.prototype.serialize = function serialize() {
    return this.map(model => model.serialize())
}
